export function RailConvList() {
  return (
    <div className="naia-rail__body flex-1 min-h-0 flex flex-col mt-3" />
  );
}
